module.exports = __webpack_public_path__ + "img/home-banner.6c90841f.png";